import type { RouteRecordRaw } from 'vue-router'
import { routes } from '@core/config/routes'

export const onboardingRoutes: RouteRecordRaw[] = [
  {
    path: routes.PROPERTY_OWNERS_PENDING,
    name: 'PROPERTY_OWNERS_PENDING',
    component: () => import('./PropertyOwnersPendingPage.vue'),
    meta: { requiresAuth: true, activeMenu: 'Property Owners' },
  },
  {
    path: routes.PROPERTY_OWNERS_KYC_REVIEW,
    name: 'PROPERTY_OWNERS_KYC_REVIEW',
    component: () => import('./PropertyOwnersKycReviewPage.vue'),
    meta: { requiresAuth: true, activeMenu: 'Property Owners' },
  },
  {
    path: routes.PROPERTY_OWNERS_BANK_VERIFICATIONS,
    name: 'PROPERTY_OWNERS_BANK_VERIFICATIONS',
    component: () => import('./PropertyOwnersBankVerificationsPage.vue'),
    meta: { requiresAuth: true, activeMenu: 'Property Owners' },
  },
  {
    path: routes.PROPERTY_OWNERS_VASP,
    name: 'PROPERTY_OWNERS_VASP',
    component: () => import('./PropertyOwnersVaspPage.vue'),
    meta: { requiresAuth: true, activeMenu: 'Property Owners' },
  },
  {
    path: routes.PROPERTY_OWNERS_KYC_EXPIRED,
    name: 'PROPERTY_OWNERS_KYC_EXPIRED',
    component: () => import('./PropertyOwnersKycExpiredPage.vue'),
    meta: { requiresAuth: true, activeMenu: 'Property Owners' },
  },
]
